import { Stack, Box, Typography, Chip } from "@mui/material";
import type { StreamEntrypointShowQueryQueryType } from "@/types/graphql/admin.generated";
import { CustomCellDate } from "@/shared/components";

interface StreamEntrypointShowProps {
  streamEntrypoint?: StreamEntrypointShowQueryQueryType["streamEntrypoint"];
  editData?: unknown;
  id?: string;
}

/**
 * Детали точки входа (read-only)
 */
export function StreamEntrypointShow({
  streamEntrypoint: entrypointProp,
  editData,
}: StreamEntrypointShowProps) {
  const entrypoint =
    entrypointProp ||
    (editData as StreamEntrypointShowQueryQueryType | undefined)
      ?.streamEntrypoint;

  if (!entrypoint) {
    return (
      <Box padding={3}>
        <Typography variant="h6" color="error">
          Точка входа не найдена
        </Typography>
      </Box>
    );
  }

  return (
    <Stack spacing={2} sx={{ p: 2 }}>
      <Typography variant="h5">{entrypoint.title}</Typography>

      <Box>
        <Typography variant="body2" color="text.secondary">
          Статус
        </Typography>
        <Chip
          label={entrypoint.liveConnected ? "Онлайн" : "Оффлайн"}
          color={entrypoint.liveConnected ? "error" : "default"}
          size="small"
        />
      </Box>

      {entrypoint.platform && (
        <Box>
          <Typography variant="body2" color="text.secondary">
            Платформа
          </Typography>
          <Typography variant="body1">{entrypoint.platform.title}</Typography>
        </Box>
      )}

      <Box>
        <Typography variant="body2" color="text.secondary">
          Эфир
        </Typography>
        <Typography variant="body1">
          {entrypoint.stream ? entrypoint.stream.title : "Свободна"}
        </Typography>
      </Box>

      {entrypoint.lastPublishAt && (
        <Box>
          <Typography variant="body2" color="text.secondary">
            Последнее подключение
          </Typography>
          <CustomCellDate date={entrypoint.lastPublishAt} />
        </Box>
      )}

      {entrypoint.lastPublishFinishAt && (
        <Box>
          <Typography variant="body2" color="text.secondary">
            Последнее отключение
          </Typography>
          <CustomCellDate date={entrypoint.lastPublishFinishAt} />
        </Box>
      )}

      {entrypoint.pull && (
        <Box>
          <Typography variant="body2" color="text.secondary">
            Pull-инжест
          </Typography>
          <Typography variant="body1">
            {entrypoint.pull.status} · попытка {entrypoint.pull.attempt} из{" "}
            {entrypoint.pull.maxAttempts}
          </Typography>
          <Typography variant="body2" fontFamily="monospace">
            {entrypoint.pull.sourceUrl}
          </Typography>
          {entrypoint.pull.lastError && (
            <Typography variant="body2" color="error">
              {entrypoint.pull.lastError.message}
            </Typography>
          )}
        </Box>
      )}

      <Box>
        <Typography variant="body2" color="text.secondary">
          Cloudflare
        </Typography>
        <Typography variant="body1" fontFamily="monospace">
          {entrypoint.cfAccountId} / {entrypoint.liveInputId}
        </Typography>
      </Box>

      <Box>
        <Typography variant="body2" color="text.secondary">
          Создана
        </Typography>
        <CustomCellDate date={entrypoint.createdAt} />
      </Box>

      <Box>
        <Typography variant="body2" color="text.secondary">
          Обновлена
        </Typography>
        <CustomCellDate date={entrypoint.updatedAt} />
      </Box>
    </Stack>
  );
}
